import { each, size } from "lodash";
import api from "../api";

const URL = "/api/front-credito";

export const retrieveTituloGrupo = async (data) => {
  return await api.post(`${URL}/titulo-grupo`, { ...data });
};

export const retrieveLogEstruturado = async (data) => {
  return await api.post(`${URL}/log-estruturado`, { ...data });
};

export const retrieveOtherProposals = async (data) => {
  return await api.get(
    `${URL}/outras-propostas?cpfCnpj=${data.cpfCnpj}&ignorarNumeroProposta=${
      data.proposalNumber ?? 0
    }&page=${data.pageable.page}&size=${data.pageable.size}&sortColumn=${
      data.pageable.sortColumn
    }&sortDirection=${data.pageable.sortDirection}`
  );
};

export const retrieveWorkflowPessoa = async (cpfCnpj, data) => {
  return await api.post(`${URL}/pedidoWorkflow/pessoa`, data);
};

export const retrieveConvenios = async () => {
  return await api.get(`${URL}/convenios`);
};

export const retrieveLojasByConvenio = async (codigoConvenio) => {
  return await api.get(`${URL}/filiais`);
};

export const retrieveCarteiras = async () => {
  return await api.get(`${URL}/carteiras`);
};

export const retrieveProdutosByGrupo = async (codigoGrupo) => {
  return await api.get(`${URL}/produtos/${codigoGrupo}`);
};

export const retrieveSituacoes = async () => {
  return await api.get(`${URL}/situacoes`);
};

export const retrieveAnalista = async () => {
  return await api.get(`${URL}/analistas`);
};

export const retrieveStatus = async () => {
  return new Promise(async (resolve, reject) => {
    return await api
      .get(`${URL}/status`)
      .then((response) => resolve(parseStatus(response)))
      .catch(reject);
  });
};

const parseStatus = (response) => {
  const resultList = [];
  findChildren(resultList, response.data, 0);
  return { ...response, data: resultList };
};

const findChildren = (resultList, itemsTree, currentLevel) => {
  each(itemsTree, (it) => {
    resultList.push({ ...it, level: currentLevel, items: undefined });
    if (size(it.items) > 0) {
      findChildren(resultList, it.items, currentLevel + 1);
    }
  });
};
